"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectWrapper = void 0;
const interfaces_1 = require("@build-5/interfaces");
const axios_1 = __importDefault(require("axios"));
const form_data_1 = __importDefault(require("form-data"));
const _1 = require(".");
const AuctionDataset_1 = require("./datasets/AuctionDataset");
const BadgesDataset_1 = require("./datasets/BadgesDataset");
const MemberDataset_1 = require("./datasets/MemberDataset");
const NftDataset_1 = require("./datasets/NftDataset");
const NftStakeDataset_1 = require("./datasets/NftStakeDataset");
const NotificationDataset_1 = require("./datasets/NotificationDataset");
const ProjectDataset_1 = require("./datasets/ProjectDataset");
const StakeDataset_1 = require("./datasets/StakeDataset");
const StakeRewardDataset_1 = require("./datasets/StakeRewardDataset");
const StampDataset_1 = require("./datasets/StampDataset");
const TickerDataset_1 = require("./datasets/TickerDataset");
const TransactionDataset_1 = require("./datasets/TransactionDataset");
const AwardDataset_1 = require("./datasets/award/AwardDataset");
const CollectionDataset_1 = require("./datasets/collection/CollectionDataset");
const MilestoneDataset_1 = require("./datasets/milestone/MilestoneDataset");
const ProposalDataset_1 = require("./datasets/proposal/ProposalDataset");
const SpaceDataset_1 = require("./datasets/space/SpaceDataset");
const AirdropDataset_1 = require("./datasets/token/AirdropDataset");
const TokenDataset_1 = require("./datasets/token/TokenDataset");
const TokenMarketDataset_1 = require("./datasets/token/TokenMarketDataset");
const TokenPurchaseDataset_1 = require("./datasets/token/TokenPurchaseDataset");
const tag_tracker_1 = require("./tag.tracker");
class ProjectWrapper {
    constructor(origin, apiKey) {
        this.origin = origin;
        this.apiKey = apiKey;
        this.trackByTag = (tag) => new tag_tracker_1.Observable(this.origin, tag);
        this.uploadFile = async (pathToFile, member, uid) => {
            const isLocal = !Object.values(_1.Build5).includes(this.origin);
            const url = this.origin + `/${isLocal ? 'https-' : ''}` + interfaces_1.WEN_FUNC.uploadFile;
            console.log(this.apiKey);
            const form = new form_data_1.default();
            form.append('member', member);
            form.append('uid', uid);
            console.log(this.origin);
            form.append('projectApiKey', this.apiKey);
            // Disabled
            console.log('FS Disabled to enable browser support', pathToFile);
            // form.append('file', fs.createReadStream(pathToFile));
            try {
                return (await axios_1.default.post(url, form)).data;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }
            catch (error) {
                throw error.response.data;
            }
        };
    }
    dataset(dataset) {
        switch (dataset) {
            case interfaces_1.Dataset.AIRDROP:
                return new AirdropDataset_1.AirdropDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.AWARD:
                return new AwardDataset_1.AwardDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.AUCTION:
                return new AuctionDataset_1.AuctionDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.BADGES:
                return new BadgesDataset_1.BadgesDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.COLLECTION:
                return new CollectionDataset_1.CollectionDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.MILESTONE:
                return new MilestoneDataset_1.MilestoneDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.MILESTONE_RMS:
                return new MilestoneDataset_1.MilestoneDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.MILESTONE_SMR:
                return new MilestoneDataset_1.MilestoneDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.MEMBER:
                return new MemberDataset_1.MemberDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.NFT:
                return new NftDataset_1.NftDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.NFT_STAKE:
                return new NftStakeDataset_1.NftStakeDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.NOTIFICATION:
                return new NotificationDataset_1.NotificationDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.PROJECT:
                return new ProjectDataset_1.ProjectDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.PROPOSAL:
                return new ProposalDataset_1.ProposalDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.SPACE:
                return new SpaceDataset_1.SpaceDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.STAKE:
                return new StakeDataset_1.StakeDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.STAKE_REWARD:
                return new StakeRewardDataset_1.StakeRewardDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.STAMP:
                return new StampDataset_1.StampDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.TOKEN:
                return new TokenDataset_1.TokenDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.TOKEN_MARKET:
                return new TokenMarketDataset_1.TokenMarketDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.TOKEN_PURCHASE:
                return new TokenPurchaseDataset_1.TokenPurchaseDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.TICKER:
                return new TickerDataset_1.TickerDataset(this.origin, this.apiKey, dataset);
            case interfaces_1.Dataset.TRANSACTION:
                return new TransactionDataset_1.TransactionDataset(this.origin, this.apiKey, dataset);
            default:
                throw Error('invalid dataset name');
        }
    }
}
exports.ProjectWrapper = ProjectWrapper;
